import React from "react";
import { number, string, func, bool } from "prop-types";
import { Button, Col } from "react-bootstrap";
import { push } from "react-router-redux";
import "!style-loader!css-loader!./styles.css";
import { trackSubscriptionBannerClick } from "utils/trackingFunctions";

const RenewBar = (props) => {
  // Props to variables
  const {
    daysRemaining,
    demoLink,
    dispatch,
    hasPricing,
    isBuyNowEligible,
    status,
    expired,
  } = props;
  const isFreeTrial = status === "free_trial";
  const isSubscriber = status === "subscriber";
  const showScheduleDemoLink = isFreeTrial && !isBuyNowEligible && !hasPricing;

  /* ----------- Event Handlers ------------ */

  const handleSubscribeButton = (event) => {
    trackSubscriptionBannerClick(event);
    dispatch(push("/subscribe"));
  };

  const handlePricingButton = (event) => {
    trackSubscriptionBannerClick(event);
    dispatch(push("/pricing"));
  };

  const handleScheduleDemo = () => {
    trackSubscriptionBannerClick("Schedule call");
    window.open(demoLink, "_blank", "noopener");
  };

  /* ----------  Set Banner UI ----------- */

  let BannerText = "";
  if (isFreeTrial) {
    BannerText = (
      <div>
        You have <span className="text-emphasize">{daysRemaining}</span> days
        left in your free Criteria trial
      </div>
    );
  }

  if (isSubscriber && daysRemaining <= 60) {
    BannerText = (
      <div>
        There are only <span className="text-emphasize">{daysRemaining}</span>{" "}
        days left in your subscription
      </div>
    );
  }

  // return early if no BannerText
  // this is to make sure the banner doesn't render if there's no text to display
  if (!BannerText) {
    return null;
  }

  const getActionButton = () => {
    let buttonText = "";
    let buttonClickHandler = null;
    let buttonId = "";

    if (isFreeTrial) {
      if (hasPricing || (isBuyNowEligible && !expired)) {
        buttonText = "Buy Now";
        buttonClickHandler = () => handleSubscribeButton(buttonText);
        buttonId = "buyNow";
      } else {
        buttonText = "Pricing Info";
        buttonClickHandler = () => handlePricingButton(buttonText);
        buttonId = "pricingInfo";
      }
    }

    if (isSubscriber && daysRemaining <= 60) {
      buttonText = "Renew Now";
      buttonClickHandler = () => handleSubscribeButton(buttonText);
      buttonId = "renewNow";
    }

    return buttonText ? (
      <Button variant="primary" onClick={buttonClickHandler} id={buttonId}>
        {buttonText}
      </Button>
    ) : null;
  };

  const ScheduleDemoLink = (
    <div>
      <span>Interested in learning more?</span>
      <button
        type="button"
        className="ml-3 btn-as-link font-weight-bold"
        onClick={handleScheduleDemo}
        id="scheduleDemo"
      >
        Schedule a Demo
      </button>
    </div>
  );

  return (
    <Col className="banner">
      <div className="banner-text-wrapper">
        <div className="banner-text">
          {BannerText}
          {getActionButton()}
        </div>
        {showScheduleDemoLink ? ScheduleDemoLink : null}
      </div>
    </Col>
  );
};

RenewBar.propTypes = {
  daysRemaining: number.isRequired,
  demoLink: string.isRequired,
  dispatch: func.isRequired,
  hasPricing: bool.isRequired,
  isBuyNowEligible: bool.isRequired,
  status: string.isRequired,
  expired: number.isRequired,
};

export default RenewBar;
